// @flow
import { colors } from 'bench-style-constants';
import React from 'react';
import styled from 'styled-components';
import { Text } from 'bench-internal-theme';

import type { AssignedPerson, Person } from './types';
import AssignmentsTableContainer from './AssignmentsTableContainer';
import NoAccountantBannerContainer from './NoAccountantBannerContainer';
import SearchAndAssignPersonContainer from './SearchAndAssignPersonContainer';
import SearchAndAssignPrimaryContactContainer from './SearchAndReplacePrimaryContactContainer';

const SectionHeader = styled.div`
  background-color: ${colors.shell};
  display: flex;
  justify-content: space-between;
  padding: 25px 45px;
`;

type UserAssignmentsProps = {
  attachedPersons: Array<AssignedPerson>,
  clientId: string,
  onClientUpdate?: () => any,
  principalPerson: Person,
};

const UserAssignments = ({
  clientId,
  attachedPersons,
  onClientUpdate,
  principalPerson,
}: UserAssignmentsProps) => (
  <div>
    <NoAccountantBannerContainer clientId={clientId} />
    <SectionHeader>
      <Text styleType="title">Primary Contact</Text>
      <SearchAndAssignPrimaryContactContainer clientId={clientId} onClientUpdate={onClientUpdate} />
    </SectionHeader>
    <AssignmentsTableContainer
      assignedPersons={[
        {
          isPrincipalPerson: true,
          person: principalPerson,
        },
      ]}
      clientId={clientId}
    />
    <SectionHeader>
      <Text styleType="title">Additional User Assignments</Text>
      <SearchAndAssignPersonContainer clientId={clientId} />
    </SectionHeader>
    <AssignmentsTableContainer assignedPersons={attachedPersons} clientId={clientId} />
  </div>
);

UserAssignments.defaultProps = {
  onClientUpdate: undefined,
};

export default UserAssignments;
